export default async (context) => {
  await context.store.dispatch('cookie-banner/nuxtClientInit', context)
}
